(function () {
  function initFloatingCart(root) {
    const sectionId = root.dataset.sectionId;
    const mainSubmit = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const mainButtons = root.closest('.product-form')?.querySelector('.product-form__buttons');
    const floatingBtn = root.querySelector('[data-floating-add-to-cart]');
    const floatingLabel = root.querySelector('[data-floating-label]');
    const floatingPrice = root.querySelector('[data-floating-price]');
    const floatingSpinner = root.querySelector('.product-floating-cart__spinner');
    const priceRoot = document.getElementById(`price-${sectionId}`);

    if (!mainSubmit || !mainButtons || !floatingBtn) return;

    function syncFromMainButton() {
      const isDisabled = mainSubmit.hasAttribute('disabled') || mainSubmit.getAttribute('aria-disabled') === 'true';
      floatingBtn.disabled = isDisabled;

      const labelEl = mainSubmit.querySelector('.product-form__submit-label');
      if (labelEl && floatingLabel) {
        floatingLabel.textContent = labelEl.textContent.trim();
      }
    }

    function syncPrice() {
      if (!priceRoot || !floatingPrice) return;
      const salePrice = priceRoot.querySelector('.price-item--sale, .price-item--last');
      const regularPrice = priceRoot.querySelector('.price-item--regular');
      const priceEl = salePrice || regularPrice;
      if (priceEl) {
        floatingPrice.textContent = priceEl.textContent.trim();
      }
    }

    function setVisible(show) {
      root.hidden = !show;
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
      root.classList.toggle('is-visible', show);
      document.body.classList.toggle('product-floating-cart-active', show);
    }

    function syncLoadingState() {
      const isLoading = mainSubmit.classList.contains('loading');
      floatingBtn.classList.toggle('loading', isLoading);
      floatingBtn.disabled = isLoading || mainSubmit.hasAttribute('disabled');
      if (floatingSpinner) {
        floatingSpinner.classList.toggle('hidden', !isLoading);
      }
    }

    floatingBtn.addEventListener('click', () => {
      if (floatingBtn.disabled) return;
      mainSubmit.click();
    });

    const buttonObserver = new MutationObserver(() => {
      syncFromMainButton();
      syncLoadingState();
    });

    buttonObserver.observe(mainSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      subtree: true,
      childList: true,
    });

    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );

    visibilityObserver.observe(mainButtons);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId && event.data.sectionId !== sectionId) return;
        syncFromMainButton();
        syncPrice();
      });
    }

    if (priceRoot) {
      const priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    syncFromMainButton();
    syncPrice();
    syncLoadingState();
  }

  function boot() {
    document.querySelectorAll('[data-product-floating-cart]').forEach(initFloatingCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
